import React from 'react';
import Loading from '../../../../../../Components/Loading';
import useRootWorkplaceInfo from '../../../../Hooks/useRootWorkplaceInfo';
import styles from './ManagerFinance.module.scss';
import BankAccountSetup from '../BankAccountSetup/BankAccountSetup';
import BillingAddressSetupWrapper from '../../../../../../Components/Manager/Components/Finance/BillingAddress/BillingAddressSetupWrapper';
import Text from '../../../../../../Components/Base/Text/Text';
import { useManagerContext } from '../../../../Services/ManagerContext';
import useStripe from '../../../../../Stripe/Hooks/useStripe';
import StripeDashboardButton from '../../../../../Stripe/Component/StripeDashboardButton/StripeDashboardButton';
import StripeRegistration from '../../../../../Stripe/Component/StripeRegistration/StripeRegistration';

const ManagerFinance: React.FC = () => {
	const { isLoading, rootWorkplace, workplace } = useRootWorkplaceInfo();
	const { isSuperAdmin } = useManagerContext();
	const { canSetupStripe, isStripeConnectConfigured } = useStripe();

	if (isLoading) {
		return <Loading />;
	}

	if (isStripeConnectConfigured) {
		return (
			<div className={styles.wrapper}>
				<Text tx='base.stipePaymentGateway' className={styles.title} />
				<Text
					tx='component.managerFinance.stripeAllowed'
					className={styles.text}
				/>
				<div className='mt-4'>
					<StripeDashboardButton workplaceId={workplace.id} />
				</div>
			</div>
		);
	}

	if (canSetupStripe) {
		return (
			<div className={styles.wrapper}>
				<Text tx='base.stipePaymentGateway' className={styles.title} />
				<StripeRegistration />
			</div>
		);
	}

	return (
		<div className={styles.wrapper}>
			<Text tx='base.bankAccount' className={styles.title} />
			<BankAccountSetup rootWorkplaceId={rootWorkplace.id} />
			<hr />
			<Text tx='base.workplaceBillingAddress' className={styles.title} />
			<BillingAddressSetupWrapper isSuperAdmin={isSuperAdmin} />
		</div>
	);
};

export default ManagerFinance;
